import { useState, useEffect } from 'react';
import { Shield, LogIn, Clock } from 'lucide-react';

export function SessionExpiredModal({ onLogin }) {
  return (
    <div data-testid="session-expired-modal" style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)',
    }}>
      <div style={{
        background: '#1a1a2e', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '16px', padding: '40px', maxWidth: '420px', width: '90%',
        textAlign: 'center', boxShadow: '0 24px 48px rgba(0,0,0,0.4)',
      }}>
        <div style={{
          width: '64px', height: '64px', borderRadius: '50%',
          background: 'rgba(239,68,68,0.15)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px',
        }}>
          <Shield size={32} color="#EF4444" />
        </div>
        <h2 style={{ color: '#fff', fontSize: '22px', fontWeight: 700, margin: '0 0 8px' }}>
          Session Expired
        </h2>
        <p style={{ color: '#9CA3AF', fontSize: '14px', lineHeight: 1.6, margin: '0 0 8px' }}>
          Your session has timed out due to 15 minutes of inactivity.
        </p>
        <p style={{ color: '#6B7280', fontSize: '13px', margin: '0 0 28px' }}>
          PCI DSS security compliance requires automatic logout after inactivity.
        </p>
        <button
          data-testid="session-expired-login-btn"
          onClick={onLogin}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: 'linear-gradient(135deg, #6366F1, #8B5CF6)',
            color: '#fff', border: 'none', borderRadius: '10px',
            padding: '12px 32px', fontSize: '15px', fontWeight: 600,
            cursor: 'pointer', transition: 'transform 0.15s, box-shadow 0.15s',
          }}
          onMouseEnter={e => { e.target.style.transform = 'translateY(-1px)'; e.target.style.boxShadow = '0 8px 20px rgba(99,102,241,0.35)'; }}
          onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
        >
          <LogIn size={18} />
          Log In Again
        </button>
      </div>
    </div>
  );
}

export function SessionWarningBanner({ onDismiss }) {
  const [seconds, setSeconds] = useState(120);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return (
    <div data-testid="session-warning-banner" style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99998,
      background: 'linear-gradient(135deg, #DC2626, #B91C1C)',
      padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
      boxShadow: '0 4px 12px rgba(220,38,38,0.35)',
      animation: 'slideDown 0.3s ease-out',
    }}>
      <style>{`@keyframes slideDown { from { transform: translateY(-100%); } to { transform: translateY(0); } }`}</style>
      <Clock size={18} color="#fff" />
      <span style={{ color: '#fff', fontSize: '14px', fontWeight: 500 }}>
        Session expires in <strong style={{ fontVariantNumeric: 'tabular-nums' }}>{mins}:{secs.toString().padStart(2, '0')}</strong> — move your mouse or press any key to stay logged in
      </span>
      <button
        data-testid="session-warning-dismiss-btn"
        onClick={onDismiss}
        style={{
          background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)',
          color: '#fff', borderRadius: '6px', padding: '4px 14px',
          fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => { e.target.style.background = 'rgba(255,255,255,0.3)'; }}
        onMouseLeave={e => { e.target.style.background = 'rgba(255,255,255,0.2)'; }}
      >
        Stay Logged In
      </button>
    </div>
  );
}
